module.exports = __webpack_public_path__ + "static/media/craveably-creamy-mb-fr.0dc93488.jpg";